import { useTranslation } from 'react-i18next';
import styles from './styles';

export interface BasicInfo {
  label: string;
  data: any;
}

interface VehicleInformationProps {
  basicInfo: BasicInfo[];
}

function VehicleInformation({ basicInfo }: VehicleInformationProps): JSX.Element {
  const { t } = useTranslation();
  const nonNullBasicInfo = basicInfo.filter((field) => field.data);

  return (
    <div className="vehicle-information">
      <div className="vehicle-info-title">{t('vdp.vehicleInfo.title')}</div>
      <div className="info-container">
        {nonNullBasicInfo.map((field, idx) => {
          return (
            <div className="vehicle-info" key={idx}>
              <div className="info-label">{t(`vdp.vehicleInfo.${field.label}`)}</div>
              <div className="info-data">{field.data}</div>
            </div>
          );
        })}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}

export default VehicleInformation;
